import { SubMenuItem } from "src/constants/modules";
import flightsImage from "src/assets/images/LandingPage/flight.png";
import hotelsImage from "src/assets/images/LandingPage/Hotels.png";
import pointsExchangeImage from "src/assets/images/LandingPage/pointsexchange.png";
import giftcardsImage from "src/assets/images/LandingPage/giftcard.png";
import discountsImage from "src/assets/images/LandingPage/discounts.png";
import { ReactNode } from "react";
import { MdFlight, MdLocalOffer, MdPayments } from "react-icons/md";

export type SectionTitle = "travel" | "mobilePayments" | "offers";

export type ModuleEntry = { type: SubMenuItem["type"]; image: string };

export type SectionEntry = { icon: ReactNode; modules: ModuleEntry[] };

const BASE_ICON_CLASSNAME = "text-font-active p-1 bg-background-primary-lighter rounded-xs";

export const SECTIONS: Record<SectionTitle, SectionEntry> = {
  travel: {
    icon: <MdFlight className={BASE_ICON_CLASSNAME} size={30} />,
    modules: [
      { type: "Travel", image: flightsImage },
      { type: "Hotel", image: hotelsImage },
    ],
  },
  mobilePayments: {
    icon: <MdPayments className={BASE_ICON_CLASSNAME} size={30} />,
    modules: [
      { type: "Loyalty", image: pointsExchangeImage },
      { type: "TopUp", image: hotelsImage },
    ],
  },
  offers: {
    icon: <MdLocalOffer className={BASE_ICON_CLASSNAME} size={30} />,
    modules: [
      { type: "Discounts", image: discountsImage },
      { type: "GiftCards", image: giftcardsImage },
    ],
  },
};

export const MODULE_STYLE = Object.values(SECTIONS)
  .flatMap(({ modules }) => modules)
  .reduce<Partial<Record<SubMenuItem["type"], { image: string }>>>((acc, { type, image }) => {
    acc[type] = { image };
    return acc;
  }, {});
